import { useMemo } from 'react';

import useDashboardWidgets from '@/features/dashboard/hooks/useDashboardWidgets';

import { DEFAULT_STOCKS_CONFIG, mergeStocksConfig, type StocksWidgetConfig } from './config';

export default function useStocksWidgetConfig(): StocksWidgetConfig {
  const { data: resolved } = useDashboardWidgets();
  return useMemo(() => {
    const entry = resolved?.find((r) => r.id === 'stocks');
    const stored = (entry?.doc?.config as Partial<StocksWidgetConfig> | undefined) ?? null;
    return stored ? mergeStocksConfig(stored) : DEFAULT_STOCKS_CONFIG;
  }, [resolved]);
}
